<template>
	<div>
		<!-- <v-dialog v-model="dialog_items" no-click-animation persistent scrollable content-class="full-height" transition="dialog-bottom-transition"> -->
	        <!-- <v-bottom-sheet persistent v-model="dialog_items" v-if="dialog_items"> -->
			<dialog ref="ref_nativeDialog" class="native_sheet" v-if="dialog_items" full-width>
				<v-card flat class="dialog_sheet_native" id="product_list" v-if="propertyObj">
					<div class="sticky-header">
						<v-subheader class="pa-0">
							<v-btn icon class="mt-0 mb-0" @click="closeDialog"><v-icon>close</v-icon></v-btn>
							{{ propertyObj.ToolbarTitle }}
							<v-spacer></v-spacer>
							<v-btn flat v-if="newProduct" icon @click="newProduct(null, null, propertyObj.action)">
								<v-icon color="primary">add</v-icon>
							</v-btn>
						</v-subheader>
						<v-text-field v-model="searchVal" @input="fn_debounceSearch" clearable single-line solo flat placeholder="Search" hide-details class="bottomsheet-search" :height="42"></v-text-field>
					</div>
					<v-card-text full-height nopadding>
						<v-list nopadding v-if="products && products.length">
							<v-list-tile v-for="(item, index) in products" :key="index" @click="setNewProduct(item.itemId, item.itemName)">
								<v-list-tile-content>
									<v-list-tile-title>{{item.itemName}}</v-list-tile-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon :color="propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'primary' : ''">{{ propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>

						<div class="pa-4 center-align display_msg" v-if="!loading && (!products || !products.length)">
							No item found!
							<!-- <v-btn small class="mt-4" capitalize outline color="primary" @click="newParty(menuItemClickParam)">
								<v-icon left class="mr-1 font16" color="primary">add</v-icon>Add New Party
							</v-btn> -->
						</div>

						<div class="pa-4 center-align display_msg" v-if="loading">
							Loading...
						</div>
					</v-card-text>
				</v-card>
			</dialog>
			<!-- </v-bottom-sheet> -->
	    <!-- </v-dialog> -->
	</div>
</template>

<script>
	export default{
		props:['setNewProduct', 'newProduct', 'menuItemClickParam', 'closeDialog'],
		data(){
			return{
				dialog_items:false,
                products:[],
				searchVal:null,
				timeoutid:null,
				loading:false,
				propertyObj:null,
				startIndex:0,
				totalItems:0,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchVal = null;
				this.propertyObj = localStorage.getItem('dialog_properties') ? JSON.parse(localStorage.getItem('dialog_properties')) : null;
				this.dialog_items = true;
				setTimeout(() => {
					// let taxDialog = document.getElementById('taxDialog');
					this.$refs['ref_nativeDialog'].showModal();
				}, 100);

				// let element = document.getElementById("product_list");

				// element.addEventListener('scroll', ()=>{
				// 	if (element.scrollHeight - element.scrollTop <= element.clientHeight)
				// 	{
				// 		console.log('scrolled');
				// 	}
				// }); 
				// let initialScrollHeight = 0;
				// let scrollYPos = 0;

				this.$nextTick(() => {
					let element = document.getElementsByClassName("native_sheet")[0];
					element.addEventListener('scroll', this.fn_onScroll); 
				})

				this.startIndex = 0;
                this.fn_getProducts();
			},
			closeDialogWeb: function () {
				let element = document.getElementsByClassName("native_sheet")[0];
				if(element){
					element.removeEventListener('scroll', this.fn_onScroll);
				}
				this.$refs['ref_nativeDialog'] ? this.$refs['ref_nativeDialog'].close() : '';
				this.dialog_items = false;
				this.products = [];
			},
			fn_onScroll: function(event){
				// !initialScrollHeight ? initialScrollHeight = element.scrollHeight : '';

				// if(scrollYPos < element.scrollTop){
				// 	if(element.scrollTop >= initialScrollHeight){
				// 		// removing items from top while scrolling down
				// 		this.products.splice(0, 50);
				// 		element.scrollTo(0,50);
				// 	}
				// }

				// scrollYPos = element.scrollTop
					
				// let element = document.getElementsByClassName("native_sheet")[0];
				if (Math.floor(event.target.scrollHeight - event.target.scrollTop) <= event.target.clientHeight)
				{
					console.log('scrolled');
					this.fn_getProducts();
				}
			},
			fn_debounceSearch: function(){
				if (this.timeoutid != null){
					clearTimeout(this.timeoutid);
				}

				this.timeoutid = setTimeout(() => { 
					this.products = [];
					this.totalItems = 0;
					this.startIndex = 0;
					this.fn_getProducts();
				},300);
			},
            fn_getProducts: function () {
				// let pageLimit = 50;
				this.loading = true;
				// this.products = null;

                let filterObject = {};
                filterObject.search = this.searchVal ? this.searchVal.toLowerCase() : '';
                // filterObject.inventory = inventory != undefined ? inventory : 1;
				filterObject.inventory = this.propertyObj.inventory != undefined ? this.propertyObj.inventory : 1;
				filterObject.groupTypeId = this.propertyObj.groupTypeId ? this.propertyObj.groupTypeId : null;
				// filterObject.startIndex = 0;
				// filterObject.startIndex = 0;
				filterObject.startIndex = this.products.length;
				filterObject.limit = 50;
				// filterObject.limit = this.products.length ? pageLimit : pageLimit + pageLimit;

                let self = this;
                this.getDialogItems("ProductDialog", filterObject, 
                    {
                        onSuccess: function(response){
							console.log(response);
                            // self.products = JSON.parse(response);
							// self.products = self.products.concat(JSON.parse(response));
							let responseJson = JSON.parse(response);
							if(responseJson.items && responseJson.items.length){
								for(let i in responseJson.items){
									self.products.push(responseJson.items[i]);
								}

								self.totalItems = responseJson.totalCount;
								self.startIndex = self.products.length;
							}

							if(self.propertyObj.selectedItem && self.propertyObj.selectedItem.itemId && self.products && self.products.length){
								// finding index of selected item
								let selectedItemIndex = self.products.findIndex(item=>item.itemId === self.propertyObj.selectedItem.itemId);
								// removing selected item from the list
								if(selectedItemIndex != -1){
									self.products.splice(selectedItemIndex, 1);
								}
								// pushing selected item to the top
								self.products.unshift(self.propertyObj.selectedItem);
							}
							self.loading = false;
                        }, 
                        onError: function(error){
                            console.log(error);
							self.loading = false;
                        }
                    }
                );
            },

			fn_onScollBottomSheet: function(element){
				// let element = event.target;
				console.log('called');
				if (element.scrollHeight - element.scrollTop <= element.clientHeight)
				{
					console.log('scrolled');
					// if(this.listItemObject.items.length && this.listItemObject.items[this.listItemObject.items.length - 1].itemIndex + 1 < this.listItemObject.totalCount){
					// 	this.fn_loadItems();
					// }
				}
			}
		},
		// mounted: function(){
		// 	// let element = document.getElementById("product_list");
		// 	let element = document.getElementsByClassName("native_sheet")[0];
		// 	element.addEventListener('scroll', ()=>{
		// 		if (element.scrollHeight - element.scrollTop <= element.clientHeight)
		// 		{
		// 			console.log('scrolled');
		// 		}
		// 	}); 
		// }
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_products.vue